module.exports = __webpack_public_path__ + "static/media/Burger.e997e23b.svg";